import { space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';
import { subSectionLabel } from '../_app.p.tournaments_.$id/page.css';

export const emptyState = style({
  height: '300px',
});

export const submissionsContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s24,
});

export const allSubmissionsLabel = style([
  subSectionLabel,
  {
    marginTop: space.s16,
    marginBottom: space.s16,
  },
]);
